<template>
	<div class="app">
		<div class="bigbox">
			<div class="cont_img">
				
			</div>
			<div class="cont_centB">
				<div class="cont_centopA">
					<div class="cont_centopAs" v-for="(items,index) in data" :key="index">
						<img :src="items.cover">
						<div class="cont_centopAlist">
							<div class="cont_centopAlis" @click="detalis(item.categoryId,item.twoCategoryId)" v-for="(item,index) in items.goodsList.slice(0,8)" :key="index">
								<img class="home-img-box" :src="item.cover">
								<!-- <h5>原价:{{item.price}}</h5> -->
                                <div style="margin-top:16px"></div>
								<div class="dis-between" style="padding:0 15px 0 0"><p class="ellipsis-nowrap">{{item.name}}</p><p><span>￥{{item.price}}元</span></p></div>
							</div>
						</div>
					</div>
				</div>
				<!-- 4f -->
			</div>
			<div class="cont_imgs"></div>
			<div class="cont_centB">
				<div class="cont_centopA">
					<div class="cont_centopAs" v-for="(items,index) in datas" :key="index">
						<img :src="items.cover">
						<div class="cont_centopAlist">
							<div class="cont_centopAlis" @click="detalis(item.categoryId,item.twoCategoryId)" v-for="(item,index) in items.goodsList.slice(0,8)" :key="index">
								<img class="home-img-box" :src="item.cover">
								<!-- <h5>原价:{{item.price}}</h5> -->
                                <div style="margin-top:16px"></div>
								<div class="dis-between" style="padding:0 15px 0 0"><p class="ellipsis-nowrap">{{item.name}}</p><p><span>￥{{item.price}}元</span></p></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:["data","datas"],
		data(){
			return{
				
			}
		},
		methods:{
			detalis(categoryId,twoCategoryId){
				if(this.authMarketAddressFn()) return
				this.$router.push({
					path:'/productlist',
					query:{
						categoryId:categoryId,
						twoCategoryId:twoCategoryId
					}
				})
			},
			// +----------------------------------------
            authMarketAddressFn() {
                let that = this
                // if ( !localStorage.getItem('token') )
                // {
                //     this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
                //     {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     } ).then( () =>
                //     {
                //         this.$router.push({path: '/login'})
                //     } ).catch( () =>
                //     {
                //         // ...
                //     } )
                //     return 1
                // }
                if (!JSON.parse( localStorage.getItem( 'marketActObj' )) || !JSON.parse( localStorage.getItem( 'AddressActObj' )) ) {
                    this.$confirm( '请选择收货地址及菜市场？', '提示',
                    {
                        confirmButtonText: '前往选择',
	                    showCancelButton: false,
						showClose: false,
						closeOnClickModal: false,
                        // cancelButtonText: '取消',
                        type: 'warning'
                    }).then( () =>
                    {
                        that.$router.push( { path: '/marketlist?num=1' } )
                    }).catch( () =>
                    {
                        // ...
                    })

                    return 1
                }
            },
            // +----------------------------------------
		}
	}
</script>

<style scoped="scoped">
	.cont_imgs{
		width: 100%;
		height: 7rem;
		background: url(../../assets/image/img/列表页/banner3.jpg);
		margin-top: 3.75rem;
	}
	.bigbox{
		background-color: #F2F2F2;
		padding-bottom: 3.125rem;
	}
	.cont_img{
		width: 100%;
		height: 7rem;
		background: url(../../assets/image/img/首页/index_banner2.png);
	}
	.cont_box {
		width: 100%;
		height: 195.0625rem;
		background-color: #F1F1F1;
		/* display: flex;
		justify-content: center; */
	}
	
	.cont_cent {
		width: 75rem;
		height: 100%;
		margin: 5.3125rem auto 0 auto;
	}
	
	.cont_centopA {
		margin-top: 3rem;
	}
	
	.cont_centopAImg {
		background: url('../../assets/image/iocn/iocnfont.png') no-repeat 0 -125px;
		width: 187px;
		height: 40px;
	}
	
	.cont_centopBImg {
		background: url('../../assets/image/iocn/iocnfont.png') no-repeat -200px -126px;
		width: 190px;
		height: 39px;
	}
	
	.cont_centopCImg {
		background: url('../../assets/image/iocn/iocnfont.png') no-repeat -400px -126px;
		width: 189px;
		height: 39px;
	
	}
	
	.cont_centopDImg {
		background: url('../../assets/image/iocn/iocnfont.png') -599px -126px;
		width: 268px;
		height: 39px;
	}
	
	.cont_centoptitle {
		display: flex;
	}
	
	.cont_centoptitle ul {
		margin-left: 6rem;
	}
	
	.cont_centoptitle li {
		float: left;
		margin: 0.5rem 1rem;
	}
	
	.cont_centoptitle p {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		line-height: 34px;
	}
	.cont_centopAs>img{
		width: 16.625rem;
		height: 32.6875rem;
	}
	.cont_centopAs {
		width: 100%;
		height: 32.6875rem;
		display: flex;
		justify-content: space-between;
		margin-top: 2rem;
	}
	
	.cont_centopAlist {
		width: 55.9375rem;
		height: 32.6875rem;
		display: flex;
		flex-wrap: wrap;
		/* align-items: flex-start | flex-end | center | baseline | stretch; */
		/* justify-content: space-between; */
		margin-top: -0.5rem;
	}
	
	.cont_centopAlis {
		width: 13.5rem;
		height: 16.0625rem;
		background: #FFFFFF;
		/* align-self: auto | flex-start | flex-end | center | baseline | stretch; */
		margin-top: 0.55rem;
		margin-right: 0.45rem;
		transition-duration: 0.4s;
		text-align: center;
		padding-top: 0.55rem;
	}
	
	.cont_centopAlis h5 {
		font-size: 12px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		text-decoration: line-through;
		color: #999999;
		margin-left: 9rem;
	}
	
	.cont_centopAlis p {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #020202;
		line-height: 34px;
		margin-left: 1rem;
	}
	
	.cont_centopAlis span {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #C30000;
		line-height: 34px;
		/* margin-left: 4rem; */
	}
	
	.cont_centopAlis:hover {
		-webkit-box-shadow: #ccc 200px 20px 20px;
		-moz-box-shadow: #ccc 10px 10px 10px;
		box-shadow: #ccc 10px 10px 10px;
		-webkit-transform: translate(0px, -5px);
		-moz-transform: translate(5px, 5px);
		background-color: #FFFFFF;
		cursor: pointer;
	}
	
	.cont_centB {
		width: 75rem;
		margin: 0 auto 0 auto;
		padding-top: 0.75rem;
	}
	
	.cont_centopAsimg {
		width: 16.625rem;
		height: 32.6875rem;
	}
	
	.index_botom {
		width: 100%;
		height: 8.3125rem;
		background: #FFFFFF;
		display: flex;
		justify-content: center;
	}
	
	.index_botcent {
		width: 75rem;
		height: 100%;
		display: flex;
		justify-content: space-between;
	}
	
	.index_botimga {
		display: flex;
	}
	
	.index_botimgaA {
		background: url('../../assets/image/iocn/iocnfont.png') no-repeat -11px -179px;
		width: 67px;
		height: 80px;
	}
	
	.index_botimgaB {
		background: url('../../assets/image/iocn/iocnfont.png') no-repeat -99px -179px;
		width: 67px;
		height: 80px;
	}
	
	.index_botimgaC {
		background: url('../../assets/image/iocn/iocnfont.png') no-repeat -188px -179px;
		width: 67px;
		height: 80px;
	}
	
	.index_botimgaD {
		background: url('../../assets/image/iocn/iocnfont.png') no-repeat -276px -179px;
		width: 67px;
		height: 80px
	}
	
	.index_botimgas {
		margin: 1.5rem;
	}
	
	.index_botimgap {
		margin: 2rem 0rem;
	}
	
	.index_botimgap p {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		line-height: 34px;
	}
	
	.index_botimgap h3 {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #020202;
		line-height: 34px;
	}
	
	
	
	
	.hun_boxB {
	  width: 100%;
	  height: 23.4375rem;
	  display: flex;
	  justify-content: center;
	  background-color: #F1F1F1;
	}
	
	.hun_jsmot {
	  width: 75rem;
	  height: 17.125rem;
	  margin-top: 3rem;
	  display: flex;
	  justify-content: space-between;
	}
	
	.hun_jsmotA {
	  width: 32.9375rem;
	  height: 17.125rem;
	  background: #FFFFFF;
	}
	
	.hun_jsmotB {
	  width: 40.8125rem;
	  height: 17rem;
	  background: #FFFFFF;
	}
	
	.hun_jsmotA_imgs {
	  display: flex;
	
	}
	
	.hun_jsmotA_imgs img {
	  padding: 2rem 1.5rem;
	}
	
	.hun_jsmotA_cent {
	  margin-top: 1.3rem;
	
	}
	
	.hun_jsmotA_cent h4 {
	  font-size: 20px;
	  font-family: Microsoft YaHei UI;
	  font-weight: 400;
	  color: #000000;
	  padding-left: 2rem;
	}
	
	.hun_jsmotA_cent p {
	  font-size: 14px;
	  font-family: Microsoft YaHei UI;
	  font-weight: 400;
	  color: #666666;
	  line-height: 16px;
	}
	
	.hun_jsmotA_cent span {
	  font-size: 12px;
	  font-family: Microsoft YaHei UI;
	  font-weight: 400;
	  color: #666666;
	  line-height: 16px;
	}
	
	.hun_jsmotA_list {
	  border-bottom: 2px solid #F2F2F2;
	  height: 2.5rem;
	  width: 15rem;
	  margin-top: 1rem;
	  padding-left: 2rem;
	
	}
	
	.hun_jsmotA_list span {
	  color: #B3B3B3;
	}
	
	.hun_jsmotA_centlin {
	  border-bottom: 5px solid #569516;
	  width: 1.875rem;
	  margin-top: 0.5rem;
	  margin-left: 2rem;
	}
	
	.hun_jsmotBtop {
	  display: flex;
	  justify-content: center;
	}
	
	.hun_jsmotBtop p {
	  font-size: 20px;
	  font-family: Microsoft YaHei UI;
	  font-weight: 400;
	  color: #000000;
	  padding-top: 1rem;
	}
	
	.hun_jsmotBtoplin {
	  border-bottom: 5px solid #569516;
	  width: 1.875rem;
	  margin: 0.5rem 19.5rem;
	}
	
	.hun_jsmotBlis {
	  display: flex;
	  justify-content: center;
	  margin-left: -3rem;
	  margin-top: 0.5rem;
	
	}
	
	.hun_jsmotBlisa {
	  margin-left: 3rem;
	}
	
	.hun_jsmotBlis p {
	  font-size: 14px;
	  font-family: Microsoft YaHei UI;
	  font-weight: 400;
	  color: #707070;
	}
	
	.hun_jsmotBlis span {
	  font-size: 12px;
	  font-family: Microsoft YaHei UI;
	  font-weight: 400;
	  color: #B3B3B3;
	}
	
	a:visited {
	  color: #707070;
	}
	
	a:link {
	  color: #b4b4b4;
	}
	
	a:hover {
	  color: #569516;
	}
</style>
